import React from 'react';
import { Link } from 'react-router-dom';
import CardGrid from './shared/CardGrid';

const WhyGermany = () => {
  const requirementsCards = [
    {
      icon: <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>,
      title: "A-Level 3 Passes",
      description: "To apply for a Bachelor's degree in Germany, you need at least 3 A-Level passes. Ensure your grades meet the program's requirements to start your higher education journey abroad."
    },
    {
      icon: <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3z"/>,
      title: "Minimum GPA of 3 for Master's",
      description: "For Master's programs in Germany, a minimum GPA of 2.8 in your undergraduate studies is typically required. Check the specific GPA criteria for the course you're applying to."
    },
    {
      icon: <path fillRule="evenodd" d="M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1z" clipRule="evenodd"/>,
      title: "IELTS 6.0 to 6.5",
      description: "You'll need an IELTS score between 6.0 and 6.5 to demonstrate your English proficiency. This is necessary for admission to most English-taught programs in Germany."
    },
    {
      icon: <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3z"/>,
      title: "No German Language Required",
      description: "You don't need to know German to apply to many programs, especially those taught in English. However, learning basic German will make living in Germany much easier."
    }
  ];

  const whyStudyCards = [
    {
      icon: <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3z"/>,
      title: "World-Class Universities",
      description: "Germany boasts some of the best universities in the world, known for their cutting-edge research and academic excellence."
    },
    {
      icon: <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>,
      title: "Affordable or Free Education",
      description: "Public universities in Germany charge little to no tuition fees, making it an attractive destination for cost-conscious students."
    },
    {
      icon: <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>,
      title: "Global Recognition",
      description: "Degrees earned in Germany are recognized worldwide, giving you a competitive edge in the job market."
    },
    {
      icon: <path fillRule="evenodd" d="M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1z" clipRule="evenodd"/>,
      title: "English-Taught Programs",
      description: "Many universities offer programs entirely in English, making it easier for non-German speakers to study."
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      {/* Hero Section */}
      <div className="text-center mb-12">
        <div className="text-6xl mb-4">🇩🇪</div>
        <h1 className="heading-tight text-4xl md:text-5xl font-bold text-gray-900 mb-4">Study in Germany</h1>
        <p className="lede max-w-3xl mx-auto mb-6">
          Studying in Germany is often cheaper than studying in a Sri Lankan private university. Public universities in Germany offer tuition-free education with world-class quality and excellent career opportunities after graduation.
        </p>
        <Link
          to="/choice"
          className="btn btn-accent"
        >
          Need Help? Contact us!
        </Link>
      </div>

      {/* Requirements Section */}
      <CardGrid 
        title="What do you need?"
        subtitle="Essential Requirements for Sri Lankan Students to Apply for Higher Studies in Germany"
        cards={requirementsCards}
      />

      {/* Why Study Section */}
      <CardGrid 
        title="Why Study in Germany?"
        subtitle="Germany has a lot to offer for Sri Lankan students, including:"
        cards={whyStudyCards}
      />

      {/* Blocked Account Section */}
      <div className="py-12 text-center section-muted rounded-lg my-12">
        <div className="text-5xl mb-4">💶</div>
        <h2 className="heading-tight text-3xl font-bold text-gray-900 mb-3">Blocked Account for Germany</h2>
        <p className="text-gray-600 max-w-3xl mx-auto mb-6">
          You'll need to open a blocked account with around €11,904 (approximately 4 million LKR). This ensures you have enough funds for living expenses. Don't worry—it's fully refundable and accessible throughout your stay.
        </p>
        <Link
          to="/choice"
          className="btn btn-accent"
        >
          Need Help With Blocked Account?
        </Link>
      </div>

      {/* Finance Section */}
      <div className="py-12">
        <h2 className="heading-tight text-3xl font-bold text-gray-900 text-center mb-3">Worried About Finance?</h2>
        <p className="lede text-center mb-8">
          We understand—it's your family's hard-earned savings. Here's how studying in Germany can be affordable.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Work While Study */}
          <div className="card p-5">
            <div className="text-3xl mb-3 text-center">💼</div>
            <h3 className="text-lg font-semibold text-center mb-2">Work While You Study</h3>
            <p className="text-sm text-gray-600 text-center">Work part-time up to 20 hours per week during semester and full-time during breaks.</p>
          </div>

          {/* Total Cost */}
          <div className="card p-5">
            <div className="text-3xl mb-3 text-center">💰</div>
            <h3 className="text-lg font-semibold text-center mb-2">Under 1.5M LKR</h3>
            <p className="text-sm text-gray-600 text-center">Total visa cost excluding living expenses often stays below 1.5 million LKR.</p>
          </div>

          {/* Blocked Account */}
          <div className="card p-5">
            <div className="text-3xl mb-3 text-center">🔐</div>
            <h3 className="text-lg font-semibold text-center mb-2">Fully Refundable</h3>
            <p className="text-sm text-gray-600 text-center">Blocked account money is accessible for your living expenses during studies.</p>
          </div>

          {/* Scholarship */}
          <div className="card p-5">
            <div className="text-3xl mb-3 text-center">🎓</div>
            <h3 className="text-lg font-semibold text-center mb-2">Scholarships Available</h3>
            <p className="text-sm text-gray-600 text-center">DAAD and Erasmus+ scholarships can cover tuition and living expenses.</p>
          </div>
        </div>
      </div>

      {/* Application Section */}
      <div className="py-12 text-center">
        <h2 className="heading-tight text-3xl font-bold text-gray-900 mb-3">Ready to Apply?</h2>
        <p className="lede max-w-3xl mx-auto mb-6">
          Find your course on DAAD.de and apply via Uni-Assist. Most German universities accept applications through Uni-Assist, a centralized portal for international students.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <a
            href="https://www.daad.de/de/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            Find Course in DAAD
          </a>
          <Link
            to="/choice"
            className="btn btn-accent"
          >
            Need Help?
          </Link>
          <a
            href="https://www.uni-assist.de/en/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            Apply via Uni-Assist
          </a>
        </div>
      </div>
    </div>
  );
};

export default WhyGermany;
